export default __webpack_public_path__ + "static/media/a2.432d6801.webp";